<template>
    <div class="pa-4">
        <v-progress-circular :size="30" :width="2" color="white" v-if="cc" indeterminate></v-progress-circular>
        <v-progress-circular :size="30" :width="2" color="accent" v-else indeterminate></v-progress-circular>
    </div>
</template>

<script>
export default {
    props: ['cc']
}
</script>
